import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getAllUsers } from "./apis";
import store from "./store";
import { getWeb3 } from "./Web3/web3";
import { connectWebsocket } from "./WebSocket";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

async function setWeb3() {
  const web3 = await getWeb3();
  if (!web3) {
    return;
  }
  // store.web3.setWeb3(web3);
  const accounts = await web3.eth.getAccounts();
  if (accounts.length == 0) {
    return;
  }
  store.account.setAccount({
    wallet: accounts[0],
  });
  connectWebsocket(accounts[0]);
}
setWeb3();

// async function fetchUserInChatroom() {
//   const users = await getAllUsers();
//   store.chatroom.setAllUsers(users);
// }
// fetchUserInChatroom();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})